import type { SessionTokens } from './tokens'
import type { User } from '../model/types'

function responseData(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== 'object' || !('success' in value) || value.success !== true || !('data' in value)
    || !value.data || typeof value.data !== 'object' || Array.isArray(value.data)) {
    throw new Error('Phản hồi đăng nhập không hợp lệ. Vui lòng thử lại.')
  }
  return value.data as Record<string, unknown>
}

export function requireSessionTokens(value: unknown): SessionTokens {
  const data = responseData(value)
  if (typeof data.access_token !== 'string' || !data.access_token || typeof data.refresh_token !== 'string'
    || !data.refresh_token || typeof data.expires_in !== 'number' || !Number.isFinite(data.expires_in) || data.expires_in <= 0) {
    throw new Error('Không thể xác nhận phiên đăng nhập.')
  }
  return data as unknown as SessionTokens
}

export function requireUser(value: unknown): User {
  const data = responseData(value)
  if (typeof data.id !== 'number' || typeof data.email !== 'string' || typeof data.role !== 'string') {
    throw new Error('Không thể tải tài khoản.')
  }
  return data as unknown as User
}
